"use strict";
/**
 * @module Services.MetricCollectors
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var topic_metric_collector_1 = require("./../../services/metric-collectors/topic-metric-collector");
/**
 * Serialiser for {@link SessionMetricCollector}
 */
var TopicMetricCollectorSerialiserClass = /** @class */ (function (_super) {
    __extends(TopicMetricCollectorSerialiserClass, _super);
    function TopicMetricCollectorSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link TopicMetricCollector} from the stream
     *
     * @param bis  the input stream
     * @return     the instance that was read
     */
    TopicMetricCollectorSerialiserClass.prototype.read = function (bis) {
        var name = Codec.readString(bis);
        var exportToPrometheus = Codec.readBoolean(bis);
        var topicSelector = Codec.readString(bis);
        var groupByTopicType = Codec.readBoolean(bis);
        return new topic_metric_collector_1.TopicMetricCollectorImpl(name, exportToPrometheus, topicSelector, groupByTopicType);
    };
    /**
     * Write a {@link TopicMetricCollector} to the stream
     *
     * @param bos    the output stream
     * @param value  the instance to be written
     */
    TopicMetricCollectorSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.name);
        Codec.writeBoolean(bos, value.exportToPrometheus);
        Codec.writeString(bos, value.topicSelector);
        Codec.writeBoolean(bos, value.groupByTopicType);
    };
    return TopicMetricCollectorSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TopicMetricCollectorSerialiserClass = TopicMetricCollectorSerialiserClass;
/**
 * The singleton
 */ // tslint:disable-next-line:variable-name
exports.TopicMetricCollectorSerialiser = new TopicMetricCollectorSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metric-collectors/topic-metric-collector-serialiser.js
// module id = 584
// module chunks = 1